<template>
  <div class="wl-results" v-if="doc">
    <results-bar
      :doc="doc"
      @loadSummary="loadSummary"
      @loadUser="loadUser"
      @loadAI="loadAI"
    ></results-bar>
    <results-summary v-if="mode === 'summary'" :id="doc.id"></results-summary>
    <results-ai v-if="mode === 'ai'" :id="doc.id"></results-ai>
    <results-user v-if="mode === 'user'" :uid="currentUser"></results-user>
  </div>
</template>

<script>
import {
  ResultsUser,
  ResultsBar,
  ResultsSummary,
  ResultsAi,
} from "@/components/results/museum";

export default {
  name: "ResultMuseum",
  props: {
    doc: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      summary: true,
      currentUser: null,
      userList: null,
      results: null,
      mode: "summary",
    };
  },
  components: {
    ResultsUser,
    ResultsBar,
    ResultsSummary,
    ResultsAi,
  },

  methods: {
    loadSummary() {
      this.currentUser = null;
      this.mode = "summary";
    },
    loadUser(uid) {
      this.currentUser = uid;
      this.mode = "user";
    },
    loadAI() {
      this.currentUser = null;
      this.mode = "ai";
    },
  },
};
</script>
